import './DailySyncToggle.scss';
import { AsyncStateAlert } from '@ui/general';
import { AsyncStateNotification } from '@ui/notifications';
import { COPY_SPECIFIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useEffect, useState } from 'react';
import { Row, Switch } from 'antd';
import { useCurrentOrganization, useUpdateOrganization } from '@hooks';
export const DailySyncToggle = () => {
    const organization = useCurrentOrganization();
    const { isErrored, isFailed, isSuccessful, request, reset } = useUpdateOrganization();
    const [toggleClicked, setToggleClicked] = useState(false);
    const [enableDailySyncVisible, setEnableDailySyncVisible] = useState(!(organization === null || organization === void 0 ? void 0 : organization.dailySyncEnabled));
    useEffect(() => {
        if ((organization === null || organization === void 0 ? void 0 : organization.id) && (isErrored || isFailed)) {
            setToggleClicked(false);
            reset();
            request({
                dailySyncEnabled: false,
                organizationId: organization.id
            });
        }
    }, [organization === null || organization === void 0 ? void 0 : organization.id, isErrored, isFailed, reset, request]);
    useEffect(() => {
        if (isSuccessful && enableDailySyncVisible) {
            setTimeout(() => setEnableDailySyncVisible(false), 2500);
        }
    }, [enableDailySyncVisible, isSuccessful]);
    const handleClick = useCallback(() => {
        if (!(organization === null || organization === void 0 ? void 0 : organization.id)) {
            return;
        }
        setToggleClicked(true);
        request({
            dailySyncEnabled: true,
            organizationId: organization.id
        });
    }, [organization === null || organization === void 0 ? void 0 : organization.id, request]);
    if (!enableDailySyncVisible) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: 'daily-sync-toggle' },
            React.createElement(AsyncStateAlert, { received: NOTIFICATIONS_COPY.SUCCESS_POST_ORGANIZATION, stateSelector: useUpdateOrganization.selectors.state }),
            !toggleClicked && COPY_SPECIFIC.DAILY_SYNCS_DISABLED,
            React.createElement(Row, { justify: 'center' }, !toggleClicked && COPY_SPECIFIC.ACTIVATE_DAILY_SYNCS),
            React.createElement(Row, { justify: 'center' },
                React.createElement(Switch, { checked: toggleClicked, checkedChildren: 'Syncs Enabled!', className: 'enable-daily-sync-toggle', disabled: toggleClicked, onClick: handleClick, unCheckedChildren: 'Syncs Disabled' }))),
        React.createElement(AsyncStateNotification, { errored: NOTIFICATIONS_COPY.ERROR_POST_ORGANIZATION, failed: NOTIFICATIONS_COPY.ERROR_POST_ORGANIZATION, stateSelector: useUpdateOrganization.selectors.state })));
};
